{
  "Accept & Continue": "__NOT__TRANSLATED__",
  "Are you sure you want to leave? Your changes will be lost.": "__NOT__TRANSLATED__",
  "Auto-fill Form": "__NOT__TRANSLATED__",
  "Auto-fill requires you to verify your identity by obtaining a verification code at your registered email address or phone number. By selecting auto-fill, you consent to receiving a text message and email with your verification code. Message & data rates may apply.": "__NOT__TRANSLATED__",
  "Canada": "__NOT__TRANSLATED__",
  "Choose the forms below to begin entering information and submit": "__NOT__TRANSLATED__",
  "City": "Ciudad",
  "Company Logo": "__NOT__TRANSLATED__",
  "Company Name": "__NOT__TRANSLATED__",
  "Complete the following fields (required by HIPAA)": "Complete los siguientes campos (requeridos por HIPAA)",
  "Complete the following fields (required by HIPAA) to securely verify your identity": "Complete los siguientes campos (requeridos por HIPAA) para verificar su identidad de manera segura",
  "Continue": "__NOT__TRANSLATED__",
  "Country": "__NOT__TRANSLATED__",
  "Date of Birth": "Fecha de nacimiento",
  "Email Address": "Correo electrónico",
  "Empty {{type}} section": "__NOT__TRANSLATED__",
  "English": "Inglesa",
  "Existing Patient": "__NOT__TRANSLATED__",
  "Fill out Manually": "__NOT__TRANSLATED__",
  "First Name": "Primer Nombre",
  "Forms": "__NOT__TRANSLATED__",
  "Forms_many": "__NOT__TRANSLATED__",
  "Forms_one": "__NOT__TRANSLATED__",
  "Forms_other": "__NOT__TRANSLATED__",
  "HIPAA Compliance": "__NOT__TRANSLATED__",
  "Hello {{patientFirstName}}!": "__NOT__TRANSLATED__",
  "Hello!": "__NOT__TRANSLATED__",
  "Kiosk Image": "__NOT__TRANSLATED__",
  "Last Name": "Apellido",
  "Leave anyway": "__NOT__TRANSLATED__",
  "Mobile Phone": "Teléfono móvil",
  "New Patient": "Nueva paciente",
  "No privacy policy found": "__NOT__TRANSLATED__",
  "No terms & conditions found": "__NOT__TRANSLATED__",
  "No {{type}} listed": "__NOT__TRANSLATED__",
  "Packets": "__NOT__TRANSLATED__",
  "Please only complete this form on a trusted device. If you're using a public device, please use caution when entering sensitive or personal information. Always close your browser window and permanently delete any file downloads when finished.": "__NOT__TRANSLATED__",
  "Please select <1>New Patient</1> or <3>Existing Patient</3> to begin.": "__NOT__TRANSLATED__",
  "Postal Code": "__NOT__TRANSLATED__",
  "Powered by": "__NOT__TRANSLATED__",
  "Privacy Policy": "__NOT__TRANSLATED__",
  "Provide the same number where you receive our reminders": "Proporcione el mismo número donde recibe nuestros recordatorios",
  "Province": "__NOT__TRANSLATED__",
  "Save time by auto-filling your information from past form submissions, or fill out the form manually.": "__NOT__TRANSLATED__",
  "Select Form": "__NOT__TRANSLATED__",
  "Select Form to fill": "__NOT__TRANSLATED__",
  "Select Language": "Seleccione el idioma",
  "Spanish": "Española",
  "State": "Estado",
  "Street Address 1": "Dirección Calle 1",
  "Street Address 2": "Dirección de calle 2",
  "Terms & Conditions": "__NOT__TRANSLATED__",
  "Terms and Conditions": "__NOT__TRANSLATED__",
  "Thank you for choosing {{companyName}}. Please take a moment to fill out the required information.": "__NOT__TRANSLATED__",
  "Thank you for choosing {{companyName}}. Please take a moment to verify and fill out the required information.": "__NOT__TRANSLATED__",
  "There are no results at the time": "__NOT__TRANSLATED__",
  "US": "__NOT__TRANSLATED__",
  "Verify Identity": "__NOT__TRANSLATED__",
  "Weave": "__NOT__TRANSLATED__",
  "Welcome": "__NOT__TRANSLATED__",
  "You have unsaved changes": "__NOT__TRANSLATED__",
  "ZIP": "Código postal",
  "ZIP Code": "__NOT__TRANSLATED__",
  "scrollDown": "__NOT__TRANSLATED__"
}
